<template>
	<BaseCard :is-editable="false" :title="$t('lawyers_contact_broker').toString()" :is-toggleable="false">
		<div v-if="showBrokerHint" class="text-sm text-gray-500 mb-4">
			{{ $t('broker_lawyer_hint') }}
		</div>

		<BaseCardRow :value="lawyerContact.company_name" :label="$t('name')" />

		<BaseCardRow v-if="lawyerContact.contact_name" :value="lawyerContact.contact_name" :label="$t('contact_person')" />

		<BaseCardRow :value="street" :label="$t('street')" />

		<BaseCardRow :value="city" :label="$t('city')" />

		<BaseCardRow :value="lawyerContact.email" :label="$t('e_mail')" />
	</BaseCard>
</template>

<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import BaseCardRow from '@/components/damagecases/forms/BaseCardRow';
import { concatArray } from '@/plugins/Utils';

export default {
	name: 'DamageAssessorCaseLawyerCard',

	components: {
		BaseCard,
		BaseCardRow,
	},

	props: {
		lawyerContact: {
			type: Object,
			required: true,
		},

		showBrokerHint: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		street() {
			return concatArray([this.lawyerContact.street, this.lawyerContact.house_number]) || '-';
		},

		city() {
			return concatArray([this.lawyerContact.city?.zip_code, this.lawyerContact.city?.name]) || '-';
		},
	},
};
</script>
